import './CardPrize.scss';
import classname from 'classnames';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { IonCard, IonCardContent, IonText, IonIcon } from '@ionic/react';
import { checkmarkCircle } from 'ionicons/icons';
import { IPrize } from 'models';
import { IconBookmark } from 'icons';

export interface CardPrizeProps extends IPrize {
  bookmark?: boolean;
  earned?: boolean;
  raffle?: any;
  onClick?: () => void;
}

const CardPrizeItem: React.FC<CardPrizeProps> = ({
  title,
  image,
  hasRaffle = false,
  linkedActivity,
  earned = false,
  raffle,
  onClick,
}) => {
  const classList = classname({
    'elanco-cardprize': true,
    'mb-3': true,
    'is-earned': earned,
  });

  return (
    <IonCard color="white" button className={classList} onClick={onClick}>
      <IonCardContent>
        <div className="elanco-cardprize--content">
          <div>
            <IonText color="secondary">
              <h4>
                {title}
                {hasRaffle ? <IconBookmark /> : null}
              </h4>
            </IonText>

            {earned ? (
              <IonText color="success">
                <p className="elanco-cardprize--status">
                  <IonIcon icon={checkmarkCircle} /> Earned
                </p>
              </IonText>
            ) : linkedActivity?.title ? (
              <IonText color="medium">
                <p className="elanco-cardprize--status">
                  Complete {linkedActivity.title} to earn
                </p>
              </IonText>
            ) : null}
          </div>
          <div
            className="elanco-cardprize--img"
            style={{ backgroundImage: `url(${image.url})` }}></div>
        </div>
      </IonCardContent>
      {raffle ? (
        <div className="elanco-cardprize--raffle">
          <div className="elanco-cardprize--raffle--title mb-2">
            <IconBookmark />
            <p>{raffle.raffleTitle}</p>
          </div>
          {documentToReactComponents(raffle.raffleDescription)}
        </div>
      ) : null}
    </IonCard>
  );
};

export default CardPrizeItem;
